import React, { useState } from "react";
import { Check, Copy } from "lucide-react";
import { ClipLoader } from "react-spinners";
import Modal from "./Modal";
import "./ShareModal.scss";

interface ShareModalProps {
  // the link if the receipt is already shared; null if it needs creating
  existingUrl: string | null;
  onCreate: () => Promise<string | null>;
  handleClose: () => void;
}

const ShareModal: React.FC<ShareModalProps> = ({
  existingUrl,
  onCreate,
  handleClose,
}) => {
  const [url, setUrl] = useState<string | null>(existingUrl);
  const [creating, setCreating] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleCreate = async () => {
    if (creating) return;
    setCreating(true);
    const created = await onCreate();
    setCreating(false);
    if (created) setUrl(created);
  };

  const handleCopy = async () => {
    if (!url) return;
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // clipboard unavailable — leave the link visible for manual copy
    }
  };

  return (
    <Modal
      className="share-modal"
      title={url ? "Share this link" : "Ready to share?"}
      handleClose={handleClose}
    >
      {url ? (
        <>
          <p>Send this link to your mates so they can pick their items.</p>
          <div className="share-row">
            <input
              className="modal-input"
              readOnly
              value={url}
              onFocus={(e) => e.target.select()}
            />
            <button className="modal-button" onClick={handleCopy}>
              {copied ? <Check size={18} /> : <Copy size={18} />}
              {copied ? "Copied" : "Copy"}
            </button>
          </div>
        </>
      ) : (
        <>
          <p style={{ textAlign: "center" }}>
            Once you create the link, the items are locked — you won't be able
            to add, remove, or edit them anymore.
          </p>
          <p style={{ textAlign: "center" }}>
            Same with your mates, except for the venmo field which is still editable
          </p>
          <button className="modal-button" onClick={handleCreate}>
            {creating ? <ClipLoader size={16} color="#fff" /> : "Create link"}
          </button>
        </>
      )}
    </Modal>
  );
};

export default ShareModal;
